import { useState, useEffect } from 'react';
import { DateTime } from 'luxon';

export default function ExpireTime({
  soonestExpiringTime,
  onExpire,
}: {
  soonestExpiringTime?: DateTime;
  onExpire?: () => void;
}) {
  const calculateExpireTime = () => {
    if (!soonestExpiringTime) return '--:--';

    const diff = soonestExpiringTime.diff(DateTime.now(), [
      'minutes',
      'seconds',
    ]);

    const totalMinutes = Math.floor(diff.as('minutes'));
    const seconds = Math.floor(diff.seconds);

    return `${String(Math.max(0, totalMinutes)).padStart(2, '0')}:${String(
      Math.max(0, seconds),
    ).padStart(2, '0')}`;
  };

  const [expireTime, setExpireTime] = useState<String>(calculateExpireTime());

  useEffect(() => {
    if (!soonestExpiringTime) {
      setExpireTime('--:--');
      onExpire?.();
      return;
    }

    const updateExpireTime = () => {
      const newExpireTime = calculateExpireTime();
      setExpireTime(newExpireTime);
      return newExpireTime === '--:--'; // If true, interval should be cleared
    };

    const interval = setInterval(() => {
      if (updateExpireTime()) {
        clearInterval(interval);
        onExpire?.();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [soonestExpiringTime]);

  return <>{expireTime}</>;
}
